import { useQuery } from "@tanstack/react-query";

// No active experiments. Add a union member here to register a new one.
export type ExperimentName = never;

type VarioqubResponse = {
  i: string;
  experiments: string;
  flags: Array<{ t: string; n: string; v: string }>;
  testids: string[];
};

async function getExperimentsData(): Promise<VarioqubResponse | null> {
  const cookie = document.cookie
    .split("; ")
    .find(c => c.startsWith("_ymab_param="))
    ?.split("=")[1];

  const url = new URL(
    "/v1/exps",
    import.meta.env.VITE_EXPERIMENTS_API_BASE_URL
  );
  url.searchParams.set(
    "client_id",
    `metrika.${import.meta.env.VITE_YANDEX_METRIKA_CLIENT_ID}`
  );
  url.searchParams.set("url", import.meta.env.VITE_LITRES_URL);
  if (cookie) {
    url.searchParams.set("i", cookie);
  }

  const response = await fetch(url, {
    headers: {
      Referer: import.meta.env.VITE_LITRES_URL,
      "User-Agent": navigator.userAgent,
    },
  });

  if (!response.ok) {
    throw new Error(`Experiments HTTP ${response.status}`);
  }

  return response.json();
}

export const experimentsQueryKey = ["experiments"] as const;

export function experimentsQueryOptions() {
  return {
    queryKey: experimentsQueryKey,
    queryFn: getExperimentsData,
  };
}

function isTruthyFlagValue(value: string | undefined): boolean {
  return value === "true" || value === "1";
}

export function checkExperiment(
  data: VarioqubResponse | null | undefined,
  expName: ExperimentName
): boolean {
  const urlExp = new URLSearchParams(window.location.search).get("exp");
  if (urlExp === expName) {
    return true;
  }

  if (!data) {
    return false;
  }

  return isTruthyFlagValue(data.flags.find(f => f.n === expName)?.v);
}

export function useExperiments() {
  const { data } = useQuery(experimentsQueryOptions());

  return {
    checkExperiment: (expName: ExperimentName) =>
      checkExperiment(data, expName),
    getYmabParam: () => data?.i || "",
  };
}
